import React, { useState, useEffect, useRef } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import ContentCard from "../../common/template/contentCard";
import ContentCardBody from "../../common/template/contentCardBody";
import Table from "../../common/table/table";
import THead from "../../common/table/tHead";
import Tr from "../../common/table/tr";
import Th from "../../common/table/th";
import TBody from "../../common/table/tBody";
import Td from "../../common/table/td";
import { getDemanda, getListaGraficoTarifaMedia, getListaGraficoTarifaMediaGeral, getListaGraficoTarifaTeTusdMensal } from "../analiseActions";
import { montarGraficoClusteredColumnMensal } from "../../common/graficos/montarGraficoClusteredColumnMensal.js";
import { montarGraficoClusteredColumnMensalSafra } from "../../common/graficos/montarGraficoClusteredColumnMensalSafra.js";
import Select from "../../common/form/select.jsx";
import Grid from "../../common/layout/grid.jsx";
import Row from "../../common/layout/row.jsx";
import Button from "../../common/button/button";
import { gerarRelatorio } from "../../fatura/faturaActions.js";
import { Loading } from "../../common/loading/loading";
import { convertToBase64 } from "../../utils/convertToBase64.js";
import LabelAndCheckbox from "../../common/form/labelAndCheckbox.jsx";
import { ModalAlert } from "../../common/dialog/modalAlert.jsx";
import { setInfo } from "../../common/toast/toast.jsx";

function analiseTarifa(props) {

    if(!props.visible) return null;
    
    const {
        state,
        contratoDemanda,
        listaGraficoTarifaMedia,
        listaGraficoTarifaMediaGeral,
        listaTarifaTeTusdMensal,
        getDemanda,
        getListaGraficoTarifaMedia,
        getListaGraficoTarifaMediaGeral,
        getListaGraficoTarifaTeTusdMensal,
        buscarPropriedadeUcFiltrada,
        setAguardando,
        filtro,
        setFiltro,
        gerarRelatorio,
    } = props;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [modalExportacaoAberto, setModalExportacaoAberto] = useState(false);
    const [graficoTarifaMediaMensal, setGraficoTarifaMediaMensal] = useState(null);
    const [graficoTarifaMediaMensalGeral, setGraficoTarifaMediaMensalGeral] = useState(null);
    const [graficoTarifaTeTusdMensal, setGraficoTarifaTeTusdMensal] = useState(null);

    const horariosTarifa = [
        { id: "0", valor: "Todos" },
        { id: "1", valor: "Fora Ponta" },
        { id: "2", valor: "Ponta" },
        { id: "3", valor: "Reservado" },
    ];
    const anoTarifaExibicao = filtro.tarifa_ano_safra ? `${filtro.ano_tarifa}/${Number(filtro.ano_tarifa) + 1}` : filtro.ano_tarifa;

    useEffect(() => {
        atualizarTodosGraficos();
        return desmontarTodosGraficos;
    }, []);

    useEffect(() => {
        const buscarDados = async () => {
            if (!state.aguardando) return;
            await Promise.all([getDemanda(), getListaGraficoTarifaMedia(), getListaGraficoTarifaMediaGeral(), getListaGraficoTarifaTeTusdMensal()]);
            setAguardando(false);
        };

        buscarDados();
        if (!state.aguardando) {
            atualizarTodosGraficos();
        }
    }, [state.aguardando]);

    useEffect(() => {
        atualizarListaGraficoTeTusdMensal();
    }, [JSON.stringify(listaTarifaTeTusdMensal)]);

    function getHorarioTarifaSelecionado(horarioTarifa) {
        const horarioSelecionado = horariosTarifa.find((item) => item.id == horarioTarifa);
        return horarioSelecionado ? horarioSelecionado.valor : "Todos";
    }

    function atualizarTodosGraficos() {
        atualizarListaGraficoTarifaMedia();
        atualizarListaGraficoTarifaMediaGeral();
        atualizarListaGraficoTeTusdMensal();
    }
    function desmontarTodosGraficos() {
        if (graficoTarifaMediaMensal) graficoTarifaMediaMensal.dispose();
        if (graficoTarifaMediaMensalGeral) graficoTarifaMediaMensalGeral.dispose();
        if (graficoTarifaTeTusdMensal) graficoTarifaTeTusdMensal.dispose();
    }

    function atualizarListaGraficoTarifaMedia() {
        const montarGraficoMensal = filtro.tarifa_ano_safra ? montarGraficoClusteredColumnMensalSafra : montarGraficoClusteredColumnMensal;
        const graficoTarifaMediaMensalAtualizado = montarGraficoMensal({
            state: state,
            component: graficoTarifaMediaMensal,
            nome: "graficoTarifaMediaMensal",
            dados: listaGraficoTarifaMedia,
            titulo: "Tarifa Média Líquida - TML (Sem Demanda e Reativos) (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoTarifaMediaMensal(graficoTarifaMediaMensalAtualizado);
    }

    function atualizarListaGraficoTarifaMediaGeral() {
        const montarGraficoMensal = filtro.tarifa_ano_safra ? montarGraficoClusteredColumnMensalSafra : montarGraficoClusteredColumnMensal;
        const graficoTarifaMediaMensalGeralAtualizado = montarGraficoMensal({
            state: state,
            component: graficoTarifaMediaMensalGeral,
            nome: "graficoTarifaMediaMensalGeral",
            dados: listaGraficoTarifaMediaGeral,
            titulo: "Tarifa Média Bruta - TMB (Com Demanda e Reativos) (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoTarifaMediaMensalGeral(graficoTarifaMediaMensalGeralAtualizado);
    }

    function atualizarListaGraficoTeTusdMensal() {
        const montarGraficoMensal = filtro.tarifa_ano_safra ? montarGraficoClusteredColumnMensalSafra : montarGraficoClusteredColumnMensal;
        const graficoTarifaTeTusdMensalAtualizado = montarGraficoMensal({
            state: state,
            component: graficoTarifaTeTusdMensal,
            nome: "graficoTarifaTeTusdMensal",
            dados: listaTarifaTeTusdMensal.map((item) => ({
                mes: item.mes,
                anos: [
                    {
                        ano: "TE",
                        valor: item.media_te,
                    },
                    {
                        ano: "TUSD",
                        valor: item.media_tusd,
                    },
                ],
            })),
            titulo: "TE e TUSD - Mensal (R$)",
            prefixo: "R$",
            sufixo: "",
        });
        setGraficoTarifaTeTusdMensal(graficoTarifaTeTusdMensalAtualizado);
    }

    function renderizarCelulasComZeros(corCiclo, listaDados) {
        let listaMeses = [];
        for (let i = listaDados.length; i < 12; i++) {
            listaMeses.push(i);
        }

        return listaMeses.map((mes) => (
            <Td key={mes} alignCenter color="#fff" backgroundColor={corCiclo}>
                0
            </Td>
        ));
    }

    async function handleExport(graficosAtivos) {
        setLoading(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };
        const calcularWidthGrafico = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.width = 900 - desconto + "px";
            } else {
                el.style.width = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
                if (getTamanhoBase() == 2500) {
                    el.style.paddingLeft = "70px";
                    el.style.width = 1180 - desconto + "px";
                }
                if (getTamanhoBase() == 4900) {
                    el.style.paddingLeft = "120px";
                    el.style.width = 1105 - desconto + "px";
                }
            }
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.width = 900 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarGrafico = ({ el }) => {
            if (el) {
                el.style.fontSize = "0.8rem";
                calcularWidthGrafico({ el });
                el.style.backgroundColor = "#30303d";
                el.style.overflowY = "hidden";
            }
        };
        const formatarTabela = ({ el }) => {
            if (el) {
                calcularWidthTabela({ el });
                el.style.color = "#FFFFFF";
                el.style.backgroundColor = "#30303d";
                el.style.paddingTop = "50px";
                el.style.paddingBottom = "50px";
                el.style.borderCollapse = "collapse";
                el.style.border = "1px solid #666682";

                // Aplica bordas também às células (th, td)
                const celulas = el.querySelectorAll("th, td");
                celulas.forEach((celula) => {
                    celula.style.border = "1px solid #666682";
                    celula.style.padding = "8px"; // Adiciona padding para melhorar a aparência
                    celula.style.textAlign = "left";
                });
            }
        };
        const exibirTagOculta = ({ el, textAlign = "left" }) => {
            if (el) {
                calcularWidthGrafico({ el, desconto: 20 });
                el.style.color = "#FFFFFF";
                el.style.fontSize = "1rem";
                el.style.fontWeight = "bold";
                el.style.backgroundColor = "#30303d";
                el.style.visibility = "visible";
                el.style.marginBottom = "0px";
                el.style.marginTop = "20px";
                el.style.padding = "10px";
                el.style.textAlign = textAlign;
            }
        };

        if (contentCardRef.current) {
            // Altera a largura e cor de fundo do gráfico antes de renderizar o conteúdo
            const graficoTarifaMediaMensal = contentCardRef.current.querySelector("#graficoTarifaMediaMensal");
            const tabelaTarifaMediaMensal = contentCardRef.current.querySelector("#tabelaTarifaMediaMensal");
            const graficoTarifaMediaMensalGeral = contentCardRef.current.querySelector("#graficoTarifaMediaMensalGeral");
            const tabelaTarifaMediaMensalGeral = contentCardRef.current.querySelector("#tabelaTarifaMediaMensalGeral");
            const periodoTarifaTeTusdMensal = contentCardRef.current.querySelector("#periodoTarifaTeTusdMensal");
            const graficoTarifaTeTusdMensal = contentCardRef.current.querySelector("#graficoTarifaTeTusdMensal");
            const tabelaTarifaTeTusdMensal = contentCardRef.current.querySelector("#tabelaTarifaTeTusdMensal");

            formatarGrafico({ el: graficoTarifaMediaMensal });
            formatarTabela({ el: tabelaTarifaMediaMensal });
            formatarGrafico({ el: graficoTarifaMediaMensalGeral });
            formatarTabela({ el: tabelaTarifaMediaMensalGeral });
            exibirTagOculta({ el: periodoTarifaTeTusdMensal });
            formatarGrafico({ el: graficoTarifaTeTusdMensal });
            formatarTabela({ el: tabelaTarifaTeTusdMensal });

            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD"><div style="width:100%; height:10%;font-family: Arial, sans-serif;">
                            <img src="${base64Cabecalho}" width="100%" />
                        </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; height:5%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                <img src="${base64Rodape}" width="100%" />
                            </div>`;

            // Captura o HTML com os estilos atualizados
            const htmlGraficoTarifaMediaMensal =
                graficosAtivos.graficoTarifaMediaMensal && graficoTarifaMediaMensal && tabelaTarifaMediaMensal
                    ? `<div style="width:100%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoTarifaMediaMensal.outerHTML +
                      tabelaTarifaMediaMensal.outerHTML +
                      "</div>"
                    : "";
            const htmlGraficoTarifaMediaMensalGeral =
                graficosAtivos.graficoTarifaMediaMensalGeral && graficoTarifaMediaMensalGeral && tabelaTarifaMediaMensalGeral
                    ? `<div style="width:100%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      graficoTarifaMediaMensalGeral.outerHTML +
                      tabelaTarifaMediaMensalGeral.outerHTML +
                      "</div>"
                    : "";

            const htmlGraficoTarifaTeTusdMensal =
                graficosAtivos.graficoTarifaTeTusdMensal && periodoTarifaTeTusdMensal && graficoTarifaTeTusdMensal && tabelaTarifaTeTusdMensal
                    ? `<div style="width:100%; height:42%; display:flex; flex-direction:column; align-items:center; justify-content:center; margin-bottom:10px; background-color:#30303d">` +
                      periodoTarifaTeTusdMensal.outerHTML +
                      graficoTarifaTeTusdMensal.outerHTML +
                      tabelaTarifaTeTusdMensal.outerHTML +
                      "</div>"
                    : "";

            const listaGraficos = [htmlGraficoTarifaMediaMensal, htmlGraficoTarifaMediaMensalGeral, htmlGraficoTarifaTeTusdMensal].filter((g) => g);
            let html = "";
            const graficosPorPagina = 2;
            for (let i = 0; i < listaGraficos.length; i += graficosPorPagina) {
                html += htmlCabecalho + listaGraficos[i] + (listaGraficos[i + 1] || `<div style="width:100%; height:42%"></div>`) + htmlRodape;
            }

            // Gera o relatório com o HTML atualizado
            await gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            setLoading(false);
            setAguardando(true);
            setAguardando(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }

    function renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal }) {
        if (filtro.tarifa_ano_safra) {
            const mesesSafra = [
                ["06", "Junho"],
                ["07", "Julho"],
                ["08", "Agosto"],
                ["09", "Setembro"],
                ["10", "Outubro"],
                ["11", "Novembro"],
                ["12", "Dezembro"],
                ["01", "Janeiro"],
                ["02", "Fevereiro"],
                ["03", "Março"],
                ["04", "Abril"],
                ["05", "Maio"],
            ];

            return mesesSafra.map(([mes, nomeMes]) => (
                <Th
                    key={mes}
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == mes ? "#66bb6a" : demandaMesFinal == mes ? "#ef5350" : null) : null,
                    }}
                >
                    {nomeMes}
                    {ucFiltradaSazonal ? (demandaMesInicial == mes ? " (I)" : demandaMesFinal == mes ? " (F)" : "") : ""}
                </Th>
            ));
        }

        return (
            <>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "01" ? "#66bb6a" : demandaMesFinal == "01" ? "#ef5350" : null) : null,
                    }}
                >
                    Janeiro
                    {ucFiltradaSazonal ? (demandaMesInicial == "01" ? " (I)" : demandaMesFinal == "01" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "02" ? "#66bb6a" : demandaMesFinal == "02" ? "#ef5350" : null) : null,
                    }}
                >
                    Fevereiro
                    {ucFiltradaSazonal ? (demandaMesInicial == "02" ? " (I)" : demandaMesFinal == "02" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "03" ? "#66bb6a" : demandaMesFinal == "03" ? "#ef5350" : null) : null,
                    }}
                >
                    Março
                    {ucFiltradaSazonal ? (demandaMesInicial == "03" ? " (I)" : demandaMesFinal == "03" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "04" ? "#66bb6a" : demandaMesFinal == "04" ? "#ef5350" : null) : null,
                    }}
                >
                    Abril
                    {ucFiltradaSazonal ? (demandaMesInicial == "04" ? " (I)" : demandaMesFinal == "04" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "05" ? "#66bb6a" : demandaMesFinal == "05" ? "#ef5350" : null) : null,
                    }}
                >
                    Maio
                    {ucFiltradaSazonal ? (demandaMesInicial == "05" ? " (I)" : demandaMesFinal == "05" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "06" ? "#66bb6a" : demandaMesFinal == "06" ? "#ef5350" : null) : null,
                    }}
                >
                    Junho
                    {ucFiltradaSazonal ? (demandaMesInicial == "06" ? " (I)" : demandaMesFinal == "06" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "07" ? "#66bb6a" : demandaMesFinal == "07" ? "#ef5350" : null) : null,
                    }}
                >
                    Julho
                    {ucFiltradaSazonal ? (demandaMesInicial == "07" ? " (I)" : demandaMesFinal == "07" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "08" ? "#66bb6a" : demandaMesFinal == "08" ? "#ef5350" : null) : null,
                    }}
                >
                    Agosto
                    {ucFiltradaSazonal ? (demandaMesInicial == "08" ? " (I)" : demandaMesFinal == "08" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "09" ? "#66bb6a" : demandaMesFinal == "09" ? "#ef5350" : null) : null,
                    }}
                >
                    Setembro
                    {ucFiltradaSazonal ? (demandaMesInicial == "09" ? " (I)" : demandaMesFinal == "09" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "10" ? "#66bb6a" : demandaMesFinal == "10" ? "#ef5350" : null) : null,
                    }}
                >
                    Outubro
                    {ucFiltradaSazonal ? (demandaMesInicial == "10" ? " (I)" : demandaMesFinal == "10" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "11" ? "#66bb6a" : demandaMesFinal == "11" ? "#ef5350" : null) : null,
                    }}
                >
                    Novembro
                    {ucFiltradaSazonal ? (demandaMesInicial == "11" ? " (I)" : demandaMesFinal == "11" ? " (F)" : "") : ""}
                </Th>
                <Th
                    alignCenter
                    style={{
                        backgroundColor: ucFiltradaSazonal ? (demandaMesInicial == "12" ? "#66bb6a" : demandaMesFinal == "12" ? "#ef5350" : null) : null,
                    }}
                >
                    Dezembro
                    {ucFiltradaSazonal ? (demandaMesInicial == "12" ? " (I)" : demandaMesFinal == "12" ? " (F)" : "") : ""}
                </Th>
            </>
        );
    }

    let ucFiltradaSazonal = false;
    let demandaMesInicial = "";
    let demandaMesFinal = "";

    //se é não sazonal, pega os últimos 12 meses,
    const mesAtualDate = new Date().getMonth(); //não soma 1 pq o mes atual não deve ser contabilizado
    const anoAtual = String(new Date().getFullYear());
    //AQUI É A LÓGICA PARA PINTAR AS CÉLULAS DE CINZA
    if (contratoDemanda) {
        const mesLimite = mesAtualDate < 10 ? "0" + mesAtualDate : String(mesAtualDate);
        const mesesDescontar = Number(mesLimite) - 11; //diminui 11 meses para pegar o mes inicial dos últimos 12 meses
        const anoInicialCalculado = mesesDescontar > 0 ? anoAtual : anoAtual - 1; //se descontando 11 meses der negativo, considera ano anterior
        const mesInicialCalculado = Number(mesLimite) + 1 > 12 ? "01" : Number(mesLimite) + 1; //mes atual 10, inicia em 10+1 do ano anterior
        const competenciaInicialCalculada = Number(String(anoInicialCalculado) + String(mesInicialCalculado)); //usada pra comparar com competencia base
        //se competencia base for maior considera ela como inicial, senão considera a calculada
        const competenciaBaseSazonalidade =
            contratoDemanda.competencia_base_sazonalidade > competenciaInicialCalculada ? contratoDemanda.competencia_base_sazonalidade : competenciaInicialCalculada;

        ucFiltradaSazonal = contratoDemanda.unidade_consumidora_sazonal;
        demandaMesInicial = ucFiltradaSazonal ? String(contratoDemanda.competencia_inicio).substring(4, 6) : String(competenciaBaseSazonalidade).substring(4, 6);
        demandaMesFinal = ucFiltradaSazonal ? String(contratoDemanda.competencia_fim).substring(4, 6) : mesLimite;
    }

    let corCiclo = "#30303d";

    let anosTarifa = [];
    listaGraficoTarifaMedia.forEach((item) => {
        item.anos.forEach((ano) => {
            if (!anosTarifa.find((itemAno) => itemAno == ano.ano)) {
                anosTarifa.push(ano.ano);
            }
        });
    });

    anosTarifa = anosTarifa.sort((a, b) => (filtro.tarifa_ano_safra ? Number(String(a).split("/")[0]) - Number(String(b).split("/")[0]) : a - b));

    let anosTarifaGeral = [];
    listaGraficoTarifaMediaGeral.forEach((item) => {
        item.anos.forEach((ano) => {
            if (!anosTarifaGeral.find((itemAno) => itemAno == ano.ano)) {
                anosTarifaGeral.push(ano.ano);
            }
        });
    });

    anosTarifaGeral = anosTarifaGeral.sort((a, b) => (filtro.tarifa_ano_safra ? Number(String(a).split("/")[0]) - Number(String(b).split("/")[0]) : a - b));

    return (
        <div ref={contentCardRef}>
            {loading && <Loading />}
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "scroll",
                    }}
                >
                    <Row alignRight style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 2 2" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                style={{ width: window.innerWidth < 768 ? "50%" : 120 }}
                                text={<span style={{ fontSize: "0.8rem", whiteSpace: "nowrap" }}>Exportar</span>}
                                title="Exportar"
                                type={"light"}
                                icon={"fa fa-file-export"}
                                event={() => {
                                    if (!filtro.id_cliente) {
                                        return setInfo("Selecione um cliente e clique em atualizar antes de exportar");
                                    }
                                    setModalExportacaoAberto(true);
                                }}
                            />
                        </Grid>
                    </Row>
                    {modalExportacaoAberto ? (
                        <ModalAlert handleClose={() => setModalExportacaoAberto(false)}>
                            <ExportAnalise />
                        </ModalAlert>
                    ) : null}
                    <div id="graficoTarifaMediaMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <Table responsive id="tabelaTarifaMediaMensal">
                            <THead>
                                <Tr>
                                    <Th>{filtro.tarifa_ano_safra ? "Safra" : "Ano"}</Th>
                                    {renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal })}
                                    <Th alignCenter>Média</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {anosTarifa.map((ano, i) => {
                                    let tarifaMediaAnual = 0;
                                    let quantidadeTarifas = 0;

                                    return (
                                        <Tr key={i}>
                                            <Td color="#fff">{ano}</Td>
                                            {listaGraficoTarifaMedia.map((mes) => {
                                                if (mes.anos.filter((anoMes) => anoMes.ano == ano).length > 0) {
                                                    return mes.anos
                                                        .filter((anoMes) => anoMes.ano == ano)
                                                        .map((anoMes) => {
                                                            if (parseFloat(anoMes.valor || 0) > 0) {
                                                                tarifaMediaAnual += parseFloat(anoMes.valor || 0);
                                                                quantidadeTarifas++;
                                                            }

                                                            return (
                                                                <Td key={anoMes.ano} alignCenter color="#fff">
                                                                    {parseFloat(anoMes.valor || 0)
                                                                        .toFixed(6)
                                                                        .replace(".", ",")}
                                                                </Td>
                                                            );
                                                        });
                                                } else {
                                                    return (
                                                        <Td key={ano} alignCenter color="#fff">
                                                            0,00
                                                        </Td>
                                                    );
                                                }
                                            })}
                                            {renderizarCelulasComZeros(corCiclo, listaGraficoTarifaMedia)}

                                            <Td alignCenter color="#fff">
                                                {(tarifaMediaAnual > 0 && quantidadeTarifas > 0 ? tarifaMediaAnual / quantidadeTarifas : 0).toFixed(6).replace(".", ",")}
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ color: "#fff", padding: 8 }}>
                <ContentCardBody
                    style={{
                        backgroundColor: "#30303d",
                        overflowX: "scroll",
                    }}
                >
                    <div id="graficoTarifaMediaMensalGeral" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <Table responsive id="tabelaTarifaMediaMensalGeral">
                            <THead>
                                <Tr>
                                    <Th>{filtro.tarifa_ano_safra ? "Safra" : "Ano"}</Th>
                                    {renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal })}
                                    <Th alignCenter>Média</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                {anosTarifaGeral.map((ano) => {
                                    let tarifaMediaAnual = 0;
                                    let quantidadeTarifas = 0;

                                    return (
                                        <Tr key={ano}>
                                            <Td color="#fff">{ano}</Td>
                                            {listaGraficoTarifaMediaGeral.map((mes) => {
                                                if (mes.anos.filter((anoMes) => anoMes.ano == ano).length > 0) {
                                                    return mes.anos
                                                        .filter((anoMes) => anoMes.ano == ano)
                                                        .map((anoMes) => {
                                                            if (parseFloat(anoMes.valor || 0) > 0) {
                                                                tarifaMediaAnual += parseFloat(anoMes.valor || 0);
                                                                quantidadeTarifas++;
                                                            }

                                                            return (
                                                                <Td key={anoMes.ano} alignCenter color="#fff">
                                                                    {parseFloat(anoMes.valor || 0)
                                                                        .toFixed(6)
                                                                        .replace(".", ",")}
                                                                </Td>
                                                            );
                                                        });
                                                } else {
                                                    return (
                                                        <Td key={ano} alignCenter color="#fff">
                                                            0,00
                                                        </Td>
                                                    );
                                                }
                                            })}
                                            {renderizarCelulasComZeros(corCiclo, listaGraficoTarifaMediaGeral)}

                                            <Td alignCenter color="#fff">
                                                {(tarifaMediaAnual > 0 && quantidadeTarifas > 0 ? tarifaMediaAnual / quantidadeTarifas : 0).toFixed(6).replace(".", ",")}
                                            </Td>
                                        </Tr>
                                    );
                                })}
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
            <ContentCard style={{ padding: 10 }}>
                <Row>
                    <Grid cols="12 12 3 3" style={{ display: "flex", flexDirection: "column", fontWeight: "400", paddingLeft: 5 }}>
                        <div className="pb-2" style={{ fontWeight: "bold" }}>
                            {filtro.tarifa_ano_safra ? "Safra" : "Ano"}
                        </div>
                        <div style={{ display: "flex", gap: 2, height: 37, justifyContent: "flex-end", fontSize: "1.1rem" }}>
                            <div
                                style={{ border: "1px solid #dfdfdf", borderRadius: 5, width: 100, cursor: "pointer" }}
                                className="p-2  d-flex justify-content-center align-items-center"
                                onClick={() => {
                                    setFiltro({
                                        ...filtro,
                                        ano_tarifa: parseInt(filtro.ano_tarifa) - 1,
                                    });
                                    getListaGraficoTarifaTeTusdMensal();
                                }}
                            >
                                {"<"}
                            </div>
                            <div className="p-2 d-flex justify-content-center align-items-center" style={{ border: "1px solid #dfdfdf", borderRadius: 5, width: "100%" }}>
                                {anoTarifaExibicao}
                            </div>
                            <div
                                style={{ border: "1px solid #dfdfdf", borderRadius: 5, width: 100, cursor: "pointer" }}
                                className="p-2  d-flex justify-content-center align-items-center"
                                onClick={() => {
                                    setFiltro({
                                        ...filtro,
                                        ano_tarifa: parseInt(filtro.ano_tarifa) + 1,
                                    });
                                    getListaGraficoTarifaTeTusdMensal();
                                }}
                            >
                                {">"}
                            </div>
                        </div>
                    </Grid>
                    <Select
                        cols="12 12 3 3"
                        name="horario_tarifa"
                        options={horariosTarifa}
                        label="Horário"
                        placeholder="Selecione o horário"
                        value={filtro.horario_tarifa}
                        isClearable={false}
                        isSearchable={false}
                        onChange={(value) => {
                            setFiltro({
                                ...filtro,
                                horario_tarifa: value,
                            });
                            getListaGraficoTarifaTeTusdMensal();
                        }}
                    />
                    <Grid cols="12 12 3 3" style={{ display: "flex", flexDirection: "column", fontWeight: "400", paddingLeft: 5 }}>
                        <div className="pb-2" style={{ fontWeight: "bold" }}>
                            Unidade Consumidora
                        </div>
                        <div style={{ display: "flex", gap: 2, height: 37, justifyContent: "flex-end", fontSize: "1rem", fontWeight: "bolder" }}>
                            <div className="p-2 d-flex align-items-center" style={{ width: "100%" }}>
                                {filtro.unidades_consumidoras.length == 1 ? buscarPropriedadeUcFiltrada("valor") : <div className="text-danger">Selecione apenas uma UC</div>}
                            </div>
                        </div>
                    </Grid>
                </Row>
                <ContentCardBody
                    style={{
                        color: "#fff",
                        backgroundColor: "#30303d",
                        overflowX: "scroll",
                    }}
                >
                    <div id="periodoTarifaTeTusdMensal" style={{ visibility: "hidden" }}>
                        <span style={{ marginRight: 20 }}>{filtro.tarifa_ano_safra ? "Safra" : "Ano"}: {anoTarifaExibicao}</span>
                        <span style={{ marginRight: 20 }}>Horário: {getHorarioTarifaSelecionado(filtro.horario_tarifa)}</span>
                        <span style={{ marginRight: 20 }}>
                            UC: {filtro.unidades_consumidoras.length == 1 ? buscarPropriedadeUcFiltrada("valor") : <div className="text-danger">Selecione apenas uma UC</div>}
                        </span>
                    </div>
                    <div id="graficoTarifaTeTusdMensal" style={{ width: "100%", minWidth: "890px", height: "400px" }}></div>
                    <div
                        style={{
                            minWidth: "890px",
                        }}
                    >
                        <Table responsive id="tabelaTarifaTeTusdMensal">
                            <THead>
                                <Tr>
                                    <Th alignCenter>Descrição</Th>
                                    {renderizarCabecalhoMeses({ ucFiltradaSazonal, demandaMesInicial, demandaMesFinal })}
                                    <Th alignCenter>Média</Th>
                                </Tr>
                            </THead>
                            <TBody>
                                <Tr>
                                    <Td alignCenter color="#fff">
                                        TE
                                    </Td>
                                    {listaTarifaTeTusdMensal.map((item, i) => (
                                        <Td key={item.mes} alignCenter color="#fff">
                                            {parseFloat(item.media_te || 0)
                                                .toFixed(6)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                    <Td alignCenter color="#fff">
                                        {(listaTarifaTeTusdMensal.filter((item) => item.media_te > 0).length //divide pela qtd de elementos com valor
                                            ? listaTarifaTeTusdMensal.reduce((acc, item) => (acc += parseFloat(item.media_te)), 0) /
                                              listaTarifaTeTusdMensal.filter((item) => item.media_te > 0).length
                                            : 0
                                        )
                                            .toFixed(6)
                                            .replace(".", ",")}
                                    </Td>
                                </Tr>
                                <Tr>
                                    <Td alignCenter color="#fff">
                                        TUSD
                                    </Td>
                                    {listaTarifaTeTusdMensal.map((item, i) => (
                                        <Td key={item.mes} alignCenter color="#fff">
                                            {parseFloat(item.media_tusd || 0)
                                                .toFixed(6)
                                                .replace(".", ",")}
                                        </Td>
                                    ))}
                                    <Td alignCenter color="#fff">
                                        {(listaTarifaTeTusdMensal.filter((item) => item.media_tusd > 0).length //divide pela qtd de elementos com valor
                                            ? listaTarifaTeTusdMensal.reduce((acc, item) => (acc += parseFloat(item.media_tusd)), 0) /
                                              listaTarifaTeTusdMensal.filter((item) => item.media_tusd > 0).length
                                            : 0
                                        )
                                            .toFixed(6)
                                            .replace(".", ",")}
                                    </Td>
                                </Tr>
                            </TBody>
                        </Table>
                    </div>
                </ContentCardBody>
            </ContentCard>
        </div>
    );

    function ExportAnalise() {
        const [graficosAtivos, setGraficosAtivos] = useState({
            graficoTarifaMediaMensal: true,
            graficoTarifaMediaMensalGeral: true,
            graficoTarifaTeTusdMensal: true,
        });

        const todosMarcados = graficosAtivos.graficoTarifaMediaMensal && graficosAtivos.graficoTarifaMediaMensalGeral && graficosAtivos.graficoTarifaTeTusdMensal;

        const existeAlgumMarcado = graficosAtivos.graficoTarifaMediaMensal || graficosAtivos.graficoTarifaMediaMensalGeral || graficosAtivos.graficoTarifaTeTusdMensal;

        return (
            <>
                <div className="d-flex flex-column justify-content-center align-items-center text-dark">
                    <p>Selecione os gráficos que deseja exportar</p>
                </div>
                <LabelAndCheckbox
                    style={{ color: todosMarcados ? "#c90028" : "#1454ff", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem", marginBottom: 25 }}
                    label={todosMarcados ? "Desmarcar Todos" : "Marcar Todos"}
                    onChange={(e) =>
                        setGraficosAtivos({
                            graficoTarifaMediaMensal: todosMarcados ? false : true,
                            graficoTarifaMediaMensalGeral: todosMarcados ? false : true,
                            graficoTarifaTeTusdMensal: todosMarcados ? false : true,
                        })
                    }
                    value={todosMarcados}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoTarifaMediaMensalCheckbox"
                    label="Tarifa Média Líquida - TML (Sem Demanda e Reativos) (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoTarifaMediaMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoTarifaMediaMensal}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoTarifaMediaMensalGeralCheckbox"
                    label="Tarifa Média Bruta - TMB (Com Demanda e Reativos) (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoTarifaMediaMensalGeral: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoTarifaMediaMensalGeral}
                />
                <LabelAndCheckbox
                    style={{ color: "#000", fontSize: window.innerWidth < 768 ? "0.7rem" : "1rem" }}
                    id="graficoTarifaTeTusdMensalCheckbox"
                    label="TE e TUSD - Mensal (R$)"
                    onChange={(e) =>
                        setGraficosAtivos({
                            ...graficosAtivos,
                            graficoTarifaTeTusdMensal: e.target.checked,
                        })
                    }
                    value={!!graficosAtivos.graficoTarifaTeTusdMensal}
                />
                <Row alignRight style={{ paddingRight: 5 }}>
                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Exportar</span>}
                            type={"info"}
                            icon={"fas fa-check"}
                            event={(e) => {
                                if (!existeAlgumMarcado) {
                                    return setInfo("Marque pelo menos um item para exportar");
                                }
                                handleExport(graficosAtivos);
                                setModalExportacaoAberto(false);
                            }}
                        />
                    </Grid>

                    <Grid cols="6 6 6 6">
                        <Button
                            text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 1rem)", whiteSpace: "nowrap" }}>Cancelar</span>}
                            type={"danger"}
                            event={() => setModalExportacaoAberto(false)}
                        />
                    </Grid>
                </Row>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    contratoDemanda: state.analise.contratoDemanda,
    listaGraficoTarifaMedia: state.analise.listaGraficoTarifaMedia,
    listaGraficoTarifaMediaGeral: state.analise.listaGraficoTarifaMediaGeral,
    listaTarifaTeTusdMensal: state.analise.listaTarifaTeTusdMensal,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getDemanda,
            getListaGraficoTarifaMedia,
            getListaGraficoTarifaMediaGeral,
            getListaGraficoTarifaTeTusdMensal,
            gerarRelatorio,
        },
        dispatch
    );
const AnaliseTarifa = connect(mapStateToProps, mapDispatchToProps)(analiseTarifa);
export { AnaliseTarifa };
